import moment from 'moment';

export const formatDateUtc = (date: number | Date, dateFormat = 'DD.MM.YYYY UTC HH:mm') => {
  return moment(new Date(date)).utc().format(dateFormat);
};
